import _newArrowCheck from "babel-runtime/helpers/newArrowCheck";
import { ApolloLink } from "apollo-link";
import { cancel, send, toObservable } from "@absinthe/socket";
import { compose } from "flow-static-land/lib/Fun";
import { print } from "graphql/language/printer";

var _this = void 0,
    getRequest = function (e) {
  var r = e.query,
      i = e.variables;
  return _newArrowCheck(this, _this), {
    operation: print(r),
    variables: i
  };
}.bind(void 0),
    notifierToObservable = function (e, r, i) {
  return _newArrowCheck(this, _this), function (n) {
    _newArrowCheck(this, _this);

    var t = void 0,
        o = !1;
    return toObservable(e, n, {
      onError: r,
      onStart: function (r) {
        _newArrowCheck(this, _this), t = r, o && cancel(e, t), i && i(r);
      }.bind(this),
      unsubscribe: function () {
        _newArrowCheck(this, _this), o = !0, t && cancel(e, t);
      }.bind(this)
    });
  }.bind(this);
}.bind(void 0),
    createAbsintheSocketLink = function (e, r, i) {
  return _newArrowCheck(this, _this), new ApolloLink(compose(notifierToObservable(e, r, i), function (r) {
    return _newArrowCheck(this, _this), send(e, r);
  }.bind(this), getRequest));
}.bind(void 0);

export { createAbsintheSocketLink };